import * as ngxTranslate from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TranslateService {
    private _translate = inject(ngxTranslate.TranslateService);
    private _parser = inject(ngxTranslate.TranslateParser);



    constructor() {
    }

    public instant(key: string, interpolateParams?: Object): string | any {
        if (!this._translate.currentLang) {
            return this._parser.interpolate(key, interpolateParams);
        } else {
            return this._translate.instant(key, interpolateParams);
        }
    }
}


